<template>
  <validable-form ref="form" @submit="submit" v-slot="{ invalid }">
    <div class="admin-login-panel box is-unselectable">
      <h3 class="admin-login-panel__title">Logowanie</h3>
      <div class="field has-addons">
        <div class="control is-expanded has-icons has-icons-left">
          <control-input
            type="email"
            rules="required|email"
            icon-left="fa-at"
            placeholder="Adres e-mail"
            v-model.trim="mail"
            success-mark="Zatwierdź, aby wysłać link na podany adres e-mail"
          />
        </div>
        <div class="control">
          <button
            type="submit"
            class="button is-primary"
            :class="{ 'is-loading': submitting }"
            :disabled="invalid || submitting"
          >
            <icon name="fa-sign-in-alt" />
          </button>
        </div>
      </div>
    </div>
  </validable-form>
</template>

<script>
import { Icon, ControlInput, ValidableForm } from "%helpers";

export default {
  name: "admin-login",

  components: {
    Icon,
    ControlInput,
    ValidableForm
  },

  data() {
    return {
      mail: "",
      submitting: false
    };
  },

  methods: {
    submit() {
      this.submitting = true;
      this.$emit("send-request", this.mail);
      this.submitting = false;
      this.mail = "";
      requestAnimationFrame(() => this.$refs.form.reset());
    }
  }
};
</script>

<style lang="scss" scoped>
.admin-login-panel__title {
  font-family: $family-sans-serif-wide;
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 1rem;
}
</style>
